import * as React from 'react';

import Typography from '@mui/material/Typography';
import {Link} from 'react-router-dom';
import {Button} from 'antd';
import {Grid} from '@mui/material';

function FooterBar() {
  return (
    <Grid item xs={12} style={{textAlign: 'center'}}>
      <Typography
        color="textSecondary"
        variant="subtitle1"
        style={{
          fontWeight: 'bold',
          fontSize: 13,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          alignContent: 'center',
        }}>
        PikaDo LLC، Suite 302, 4001 Kennett Pike, County of New Castle,
        Wilmington, Delaware 19807, USA
      </Typography>
      <div
        style={{
          textAlign: 'center',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          paddingBottom: 30,
        }}>
        <Link
          style={{
            fontWeight: 'bold',
            fontSize: 12,
          }}
          to={{
            pathname: 'https://pikado.io/',
          }}
          target="_blank">
          www.PikaDo.io
        </Link>
        &nbsp; &nbsp;
        <a
          style={{
            fontWeight: 'bold',
            fontSize: 12,
            color: '#0D6EFD',
            textDecoration: 'underline',
          }}
          onClick={() => {
            window.open(`mailto:info@PikaDo.io?subject=QA`);
          }}
          target="_blank">
          info@PikaDo.io
        </a>
      </div>
    </Grid>
  );
}
export default FooterBar;
